document.addEventListener('DOMContentLoaded', function () {

  // const intervalId = setInterval(async () => {
  //   const boldOptionsLoaded = document.querySelector(
  //     '.bold_options.bold_options_loaded .bold_option_total'
  //   );

  //   if (boldOptionsLoaded) {
  //     clearInterval(intervalId);
  //     setTimeout(async()=>{
  //       const pdpSectionWrapper = document.querySelector('.product-form__buttons');
  //       if (pdpSectionWrapper) {
  //           pdpSectionWrapper.classList.remove('yy_unavailable');
  //       }
  //     },1000);
  //   }
  // }, 800);

  // ----------------------------------------
  // 1. IE‐fallback for Variant Switcher
  // ----------------------------------------
  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');
    return (msie > 0 || trident > 0);
  }

  if (isIE()) {
    // ※ Changed from:
    //    document.querySelector('#{{ product_form_id }} input[name="id"]');
    //   to a generic selector: any form with class "product-form" that has an <input name="id">
    const hiddenInput = document.querySelector(
      'form.product-form input[name="id"]'
    );

    // ※ Changed from:
    //   document.querySelector('variant-radios[data-section="{{ section.id }}"]')
    //   to: pick the first <variant-radios> or <variant-selects> on the page
    const variantSwitcher =
      document.querySelector('variant-radios') ||
      document.querySelector('variant-selects');

    // ※ Changed from grabbing a ".product-form__noscript-wrapper-{{ section.id }}" by literal class
    //   to: look for any ".product-form__noscript-wrapper" inside the same form
    const noScriptInputWrapper = document.createElement('div');
    const noscriptLoc = document.querySelector(
      '.product-form__noscript-wrapper'
    );
    if (noscriptLoc) {
      noScriptInputWrapper.innerHTML = noscriptLoc.textContent;
    }

    if (variantSwitcher && noScriptInputWrapper) {
      variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;
    }

    // Listen for change on the (now‐replaced) select/radio
    const variantsSelect = document.querySelector(
      '#Variants select'
    ); // or adjust if your theme uses a different container
    if (variantsSelect && hiddenInput) {
      variantsSelect.addEventListener('change', function (event) {
        hiddenInput.value = event.currentTarget.value;
      });
    }
  }


  // ------------------------------------------------------
  // 2. Quantity‐based Price Update
  // ------------------------------------------------------
  // Capture the quantity input field
  var quantityInput = document.querySelector('.quantity__input');
  // Find the element that contains the price inside the '.price-id' container
  var priceContainer = document.querySelector('.price-id');
  var priceElement =
    priceContainer && priceContainer.querySelector('.price__regular .money');

  var basePriceText = priceElement
    ? priceElement.textContent.trim()
    : null;
  var basePrice = basePriceText
    ? parseFloat(basePriceText.replace(/[^0-9.-]+/g, ''))
    : 0;

  if (isNaN(basePrice)) {
    console.error('Base price is not a valid number:', basePriceText);
  } else if (quantityInput && priceElement) {
    function updatePrice() {
      var qty = parseInt(quantityInput.value, 10) || 1;
      var newPrice = basePrice * qty;
      var currencySymbol = basePriceText.replace(/[0-9.,\s]/g, '');

      priceElement.innerHTML = currencySymbol + newPrice.toFixed(2);
    }

    quantityInput.addEventListener('input', updatePrice);

    var plusBtn = document.querySelector(
      '.quantity__button[name="plus"]'
    );
    var minusBtn = document.querySelector(
      '.quantity__button[name="minus"]'
    );
    if (plusBtn) plusBtn.addEventListener('click', updatePrice);
    if (minusBtn) minusBtn.addEventListener('click', updatePrice);
  }


  // ------------------------------------------------------
  // 3. Frame‐Color Image Update & Sync
  // ------------------------------------------------------
  // 3.1 Sync from custom UI -> Bold (on click)
  // document.querySelectorAll('.frame_color_class').forEach(function (input) {
  //   input.addEventListener('change', function () {
  //     var selectedVal = input.value.trim();
  //     console.log('🟢 Clicked Frame:', selectedVal);

  //     // Deselect all custom checkboxes
  //     document.querySelectorAll('.frame_color_class').forEach(cb => {
  //       cb.checked = false;
  //     });
  //     input.checked = true;

  //     // Remove 'selected' class from all .bold_option_value_element
  //     document
  //       .querySelectorAll('.bold_option_value_element')
  //       .forEach(el => {
  //         el.classList.remove('selected');
  //       });

  //     // Add 'selected' class to current wrapper
  //     var boldWrapper = input.closest('.bold_option_value_element');
  //     if (boldWrapper) boldWrapper.classList.add('selected');

  //     // Sync to Bold checkbox(s) that share the same value
  //     document
  //       .querySelectorAll(
  //         'input[type="checkbox"][value="' + selectedVal + '"]'
  //       )
  //       .forEach(function (cb) {
  //         // ※ Changed: only click those that have the Bold‐specific class 
  //         if (cb.classList.contains('sw_973889_873583') && !cb.checked) {
  //           cb.click();
  //           console.log('✔️ Triggered Bold click for', selectedVal);
  //         }
  //       });
  //   });
  // });

  // 3.2 Sync from Bold -> Custom on page load
  function syncFrameOnLoad() {
    var selectedBold = Array.from(
      document.querySelectorAll('.sw_973889_873583')
    ).find(cb => cb.checked);

    if (selectedBold) {
      var selectedVal = selectedBold.value.trim();
      console.log('📦 Page Load Detected Bold Frame:', selectedVal);

      var customInput = document.querySelector(
        '.frame_color_class[value="' + selectedVal + '"]'
      );
      if (customInput) {
        customInput.checked = true;
        var wrapper = customInput.closest('.bold_option_value_element');
        if (wrapper) wrapper.classList.add('selected');
      }
    }
  }
   setTimeout(syncFrameOnLoad, 300);


  // 3.3 Featured‐Image Update Logic
  var lastImageUrl = '';

  function getCheckedValue(selector) {
    var el = document.querySelector(selector + ':checked');
    return el ? el.value.trim() : '';
   
  }

  function getFrameColor() {
    return getCheckedValue('input[name="Frame Colour"]');
  }

  function getDeskColor() {
    return getCheckedValue('input[name="Desk Top Colour"]');
  }

  function getSize() {
    return getCheckedValue('input[name="Desk Top Size(cm)"]');
  }

    function updateFeaturedImage() {
              var frameColor = getFrameColor();
              var deskColor = getDeskColor();
              var size = getSize();

              
              if (!frameColor || !size) return;
              if (size === 'Frame Only' && deskColor !== 'No Desktop') return;
              if (size !== 'Frame Only' && (!deskColor || deskColor === 'No Desktop')) return;

              var matchFound = false;

              document.querySelectorAll('.image_swatch').forEach(function(swatchEl) {
                  var frame = swatchEl.querySelector('#frame span')?.textContent.trim();
                  var desk = swatchEl.querySelector('#desk span')?.textContent.trim();
                  var img = swatchEl.querySelector('#swatch span')?.textContent.trim();

                  if (frame === frameColor && desk === deskColor && img && img.trim() !== '') {
                        // Prevent reloading same image
                        if (lastImageUrl === img) return;

                        var timestampedImg = img + '?v=' + Date.now();

                        document.querySelectorAll(
                          '.product__photo.is-selected img, .product__photo--additional.is-selected img'
                        ).forEach(function (mediaEl) {

                          var container = mediaEl.closest('.product__aspect-ratio-container');
                          if (!container) return;

                          var previousSrc = mediaEl.getAttribute('src');

                          var preloader = new Image();

                          preloader.onload = function () {
                            mediaEl.src = this.src;
                            mediaEl.removeAttribute('srcset');
                            mediaEl.dataset.src = this.src;
                            mediaEl.removeAttribute('data-srcset');

                            mediaEl.style.transition = 'opacity 0.2s ease-in';
                            mediaEl.style.opacity = '1';
                            mediaEl.style.visibility = 'visible';

                            container.style.paddingTop = '100%';

                            // ✅ update only on success
                            lastImageUrl = img;
                          };

                          preloader.onerror = function () {
                            console.warn('[IMAGE] Load failed → keeping previous image');
                            mediaEl.src = previousSrc;
                          };

                          preloader.src = timestampedImg;
                        });
                      }

                  
              });

              if (!matchFound) {
                // console.log('[IMAGE] No valid matching image found → keeping last image');
                return;
              }
        }


    // Wait for Bold options to settle
    function waitForStableBoldAndResync() {
        let lastHTML = '';
        let checkCount = 0;
        const observerTarget = document.querySelector('.bold_option'); // Use a stable wrapper if needed

        if (!observerTarget) {
            console.warn("⚠️ Bold wrapper not found.");
            return;
        }

        const observer = new MutationObserver(() => {
            const currentHTML = observerTarget.innerHTML;
            if (currentHTML === lastHTML) {
                checkCount++;
            } else {
                checkCount = 0;
                lastHTML = currentHTML;
            }

            if (checkCount >= 3) {
                observer.disconnect();
                console.log("✅ Bold options settled, syncing now.");
                reSyncCustomOptionsToBold();
            }
        });

        observer.observe(observerTarget, {
            childList: true,
            subtree: true
        });
    }

    // Re-sync custom options to Bold
    function reSyncCustomOptionsToBold() {
        document.querySelectorAll('.options_checkbox[data-id]').forEach(function (customCheckbox) {
            if (!customCheckbox.checked) return;

            const selectedId = customCheckbox.dataset.id;

            // Find Bold visible checkbox input
            const boldEl = document.querySelector(
                'input[type="checkbox"][value="' + selectedId + '"]'
            );
            if (!boldEl) return;

            const wrapper = boldEl.closest('.bold_option_value_element');

            // Ensure checkbox is checked
            if (!boldEl.checked) {
                boldEl.click();
            }

            // Add visual class if not already
            if (wrapper && !wrapper.classList.contains('bold_swatch_selected')) {
                wrapper.classList.add('bold_swatch_selected');
                wrapper.setAttribute('aria-checked', 'true');
            }

            // Update the hidden helper field
            const hiddenInput = wrapper?.querySelector('input[type="hidden"]');
            if (hiddenInput && hiddenInput.name && hiddenInput.name.includes('[' + selectedId + ']')) {
                hiddenInput.value = selectedId;
            }
        });
    }


    // Ensure the image syncs when a thumbnail is clicked
document.querySelectorAll('.product__slider-thumbnail').forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
        // --- Get image URL from thumbnail ---
        var imageSrc =
            thumbnail.getAttribute('data-src') ||
            thumbnail.getAttribute('data-srcset') ||
            thumbnail.getAttribute('srcset') ||
            thumbnail.getAttribute('src');

        // --- Update main featured image directly ---
        updateFeaturedImageDirect(imageSrc);

        // --- Sync slider highlight (blue border) ---
        document.querySelectorAll('.product__slider-thumbnail').forEach(t => {
            t.classList.remove('is-selected', 'is-active');
        });
        thumbnail.classList.add('is-selected', 'is-active');
    });
});


// --- Helper function to update main image instantly ---
function updateFeaturedImageDirect(imgUrl) {
    document.querySelectorAll(
        '.product__photo.is-selected img, .product__photo--additional.is-selected img'
    ).forEach(function (mediaEl) {

        var container = mediaEl.closest('.product__aspect-ratio-container');
        if (!container) return;

        mediaEl.style.opacity = '0';
        mediaEl.style.visibility = 'hidden';

        var preloader = new Image();
        preloader.onload = function () {
            mediaEl.src = this.src;
            mediaEl.removeAttribute('srcset');
            mediaEl.dataset.src = this.src;
            mediaEl.removeAttribute('data-srcset');

            mediaEl.classList.add('lazyloaded');
            mediaEl.loading = 'eager';

            mediaEl.style.visibility = 'visible';
            mediaEl.style.transition = 'opacity 0.2s ease-in';
            mediaEl.style.opacity = '1';
        };

        preloader.src = imgUrl;
    });
}


    // Helper function to extract desk color from alt text (works for two-word colors like "White Pine")
    function extractDeskColorFromAlt(altText) {
        if (altText) {
            var parts = altText.split(' ');
            // If the first two words make a valid color, return them (e.g., "White Pine")
            if (parts.length > 1) {
                return parts[0] + ' ' + parts[1];  // "White Pine"
            } else {
                return parts[0];  // Single word colors like "White", "Black"
            }
        }
        return '';  // Default to empty if no valid color found
    }

    // Ensure image syncs when a variant option is changed
    document.addEventListener('change', function (e) {
        const isVariantChange =
            e.target.matches('input[name="Frame Colour"]') ||
            e.target.matches('input[name="Desk Top Size"]') ||
            e.target.matches('input[name="Desk Top Colour"]');

        if (isVariantChange) {
            // console.log('[DEBUG] Option changed.');
            updateFeaturedImage();
            waitForStableBoldAndResync();
        }
    });

    // Delay initial image update
    // setTimeout(updateFeaturedImage,100);
    updateFeaturedImage();


// ------------------------------------------------------
// 4. Bold Option Title Toggle & Sync
// ------------------------------------------------------
document.querySelectorAll('.bold_option_title').forEach(function (titleEl) {
  titleEl.addEventListener('click', function () {
    var subOption = titleEl.closest('.sub-options');
    var checkbox = subOption?.querySelector('input.options_checkbox');
    var selectedId = checkbox?.dataset.id;
    if (!selectedId) {
      console.warn('⚠️ No data-id found.');
      return;
    }

    var baseKey = selectedId.split(':')[0].trim();
    var isAlreadySelected = titleEl.classList.contains('selected');

    if (isAlreadySelected) {
      // Deselect custom
      checkbox.checked = false;
      var siblingCheckmark = checkbox
        .closest('label')
        ?.querySelector('.checkmark');
      if (siblingCheckmark) siblingCheckmark.classList.remove('checked');
      titleEl.classList.remove('selected');

      // Deselect matching BOLD checkboxes
      document
        .querySelectorAll(
          'input[type="checkbox"][value="' + selectedId + '"]'
        )
        .forEach(function (el) {
          if (el.checked) el.click();
        });
      return;
    }

    // Uncheck other custom checkboxes in same group
    document
      .querySelectorAll('.options_checkbox[data-id]')
      .forEach(function (cb) {
        var val = cb.dataset.id;
        if (val && val.split(':')[0].trim() === baseKey && val !== selectedId) {
          cb.checked = false;
          var otherCheckmark = cb
            .closest('label')
            ?.querySelector('.checkmark');
          if (otherCheckmark) otherCheckmark.classList.remove('checked');
          var otherTitle = cb
            .closest('.sub-options')
            ?.querySelector('.bold_option_title');
          if (otherTitle) otherTitle.classList.remove('selected');
        }
      });

    // Check current custom checkbox
    checkbox.checked = true;
    var newCheckmark = checkbox
      .closest('label')
      ?.querySelector('.checkmark');
    if (newCheckmark) newCheckmark.classList.add('checked');
    titleEl.classList.add('selected');

    // Sync to BOLD
    document
      .querySelectorAll('input[type="checkbox"][value]')
      .forEach(function (boldEl) {
        var val = boldEl.value;
        var key = val.split(':')[0].trim();
        if (key === baseKey) {
          if (val === selectedId && !boldEl.checked) {
            boldEl.click();
          } else if (val !== selectedId && boldEl.checked) {
            boldEl.click();
          }
        }
      });
  });
});


// ------------------------------------------------------
// 5. Delivery Options Click Handler (with debug logging)
// ------------------------------------------------------
// document.addEventListener('DOMContentLoaded', function () {
//   const select = document.getElementById('deliveryOptions');
//   if (!select) return;

//   select.addEventListener('change', function () {
//     const selectedVal = select.value;
//     console.log('[DELIVERY] Selected value:', selectedVal);

//     // 🔁 Deselect all delivery-related Bold options
//     const baseKey = 'Delivery Options'; // <-- Make sure this matches Bold option title prefix
//     document.querySelectorAll('.bold_option input[type="checkbox"]').forEach(function (boldCb) {
//       const boldVal = boldCb.value;
//       const boldKey = boldVal.split(':')[0].trim();

//       if (boldKey === baseKey) {
//         const isMatch = boldVal.toLowerCase().includes(selectedVal.toLowerCase());
//         if (isMatch && !boldCb.checked) {
//           console.log('[DELIVERY] ✅ Selecting:', boldVal);
//           boldCb.click();
//         } else if (!isMatch && boldCb.checked) {
//           console.log('[DELIVERY] ❌ Deselecting:', boldVal);
//           boldCb.click();
//         }
//       }
//     });
//   });
// });




// ------------------------------------------------------
// 6. Frame‐Only-Set Click Handler (Adds radio support for frame colour only)
// ------------------------------------------------------
document
  .querySelectorAll('.frame-only-set .bold_option_value_element')
  .forEach(function (el) {
    el.addEventListener('click', function () {
      var input = el.querySelector('.frame_color_class');
      var selectedValue = input?.value;
      if (!input || input.checked) return;

      // ✅ Click matching BOLD checkbox(s) — for most products
      document
        .querySelectorAll('input[type="checkbox"][value="' + selectedValue + '"]')
        .forEach(function (cb) {
          if (!cb.checked) cb.click();
        });

      // ✅ Click matching BOLD radio — for Pro 1 frame colour only
      document
        .querySelectorAll('.bold_option_radio input[type="radio"][value="' + selectedValue + '"]')
        .forEach(function (rb) {
          if (!rb.checked) rb.click();
        });
    });
  });



// ------------------------------------------------------
// 7. Append Note on “Frame Only” Labels
// ------------------------------------------------------
// document.querySelectorAll('.swatch-element__text').forEach(function (label) {
//   if (label.textContent.trim() === 'Frame Only' && !label.querySelector('b')) {
//     label.innerHTML +=
//       '<br><span class="frame-note">Reuse existing desktop</span>';
//   }
// });


// ------------------------------------------------------
// 8. Auto-select Default Frame Color (Black for Pro 1, Silver for others)
// ------------------------------------------------------
(function () {
  var isPro1 = window.location.pathname.includes('/products/yo-yo-desk-pro-1') ||
    window.location.pathname.includes('/products/yo-yo-desk-duo');
  var defaultColor = isPro1 ? 'Black' : 'Silver';

  // ✅ Select in custom UI
  var customInput = document.querySelector(
    '.frame_color_class[value="' + defaultColor + '"]'
  );
  if (customInput && !customInput.checked) {
    customInput.checked = true;

    var checkmark = customInput.closest('label')?.querySelector('.checkmark');
    if (checkmark) checkmark.classList.add('checked');

    var wrapper = customInput.closest('.bold_option_value_element');
    if (wrapper) wrapper.classList.add('selected');
  }

  // ✅ Select in Bold Options – support both checkbox and radio
  var boldInput =
    document.querySelector('.bold_option input[type="checkbox"][value="' + defaultColor + '"]') ||
    document.querySelector('.bold_option input[type="radio"][value="' + defaultColor + '"]');

  if (boldInput && !boldInput.checked) {
    boldInput.click(); // ✅ Triggers Bold internal logic
  }
})();



// ------------------------------------------------------
// 9. Porthole Auto-Selection & Hide/Show Logic
// ------------------------------------------------------

// Function to auto-select the Control Switch tab when the Porthole is not visible
function autoSelectControlSwitch() {
  const controlSwitchTab = document.querySelector('.accessory-tab[data-tab="control-switch"]');
  
  if (controlSwitchTab) {
    // Simulate a click on the Control Switch tab to activate it
    controlSwitchTab.click();
  }
}

(function () {
  const portholeSection = document.querySelector('#portholes');
  const sizeInputs = document.querySelectorAll('input[name="Desk Top Size"]');
  const disableSizes = ['Frame Only', '100x60cm', '120x70cm'];
  const silverPortholeValue = 'Portholes: 2 x Plastic Grommets : SILVER';
  const noPortholesValue = 'NO PORTHOLES';

  function handlePortholeLogic(selectedSize) {
    if (!portholeSection) return;

    const isDisabled = disableSizes.includes(selectedSize);

    if (isDisabled) {
      portholeSection.style.display = 'none';

      // ✅ Uncheck all porthole-related Bold Options
      document.querySelectorAll('.bold_option_swatch').forEach(optionBlock => {
        const title = optionBlock.querySelector('.bold_option_title')?.textContent?.trim() || '';
        if (/PORTHOLES/i.test(title)) {
          const input = optionBlock.querySelector('input[type="checkbox"]:checked');
          if (input) input.click();
        }
      });

      // ✅ Select "NO PORTHOLES"
      document.querySelectorAll('.bold_option_swatch').forEach(optionBlock => {
        const title = optionBlock.querySelector('.bold_option_title')?.textContent?.trim() || '';
        if (title.toUpperCase() === noPortholesValue) {
          const input = optionBlock.querySelector('input[type="checkbox"]');
          if (input && !input.checked) input.click();
        }
      });

      // ✅ Uncheck custom swatches
      portholeSection.querySelectorAll('input.options_checkbox:checked').forEach(cb => {
        cb.checked = false;
        cb.dispatchEvent(new Event('change', { bubbles: true }));

        const checkmark = cb.closest('.bold_option_element')?.querySelector('.checkmark');
        if (checkmark) checkmark.classList.remove('checked');

        const title = cb.closest('.sub-options')?.querySelector('.bold_option_title');
        if (title) title.classList.remove('selected');
      });

      autoSelectControlSwitch();

    } else {
      portholeSection.style.display = 'block';

      // ✅ Uncheck "NO PORTHOLES" everywhere
      document.querySelectorAll('.bold_option_swatch').forEach(optionBlock => {
        const title = optionBlock.querySelector('.bold_option_title')?.textContent?.trim() || '';
        if (title.toUpperCase() === noPortholesValue) {
          const input = optionBlock.querySelector('input[type="checkbox"]:checked');
          if (input) input.click();
        }
      });

      // ✅ Select SILVER Porthole in Bold Options
      document.querySelectorAll('.bold_option_swatch').forEach(optionBlock => {
        const title = optionBlock.querySelector('.bold_option_title')?.textContent?.trim() || '';
        if (title === silverPortholeValue) {
          const input = optionBlock.querySelector('input[type="checkbox"]');
          if (input && !input.checked) input.click();
        }
      });

      // ✅ Select custom UI swatch for Silver
      portholeSection.querySelectorAll(`input.options_checkbox[data-id="${silverPortholeValue}"]`).forEach(cb => {
        cb.checked = true;

        const checkmark = cb.closest('.bold_option_element')?.querySelector('.checkmark');
        if (checkmark) checkmark.classList.add('checked');

        const title = cb.closest('.sub-options')?.querySelector('.bold_option_title');
        if (title) title.classList.add('selected');
      });
    }
  }

  // Bind change listeners
  sizeInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      handlePortholeLogic(this.value);
    });
  });

  // Run on initial load
  const selectedInput = document.querySelector('input[name="Desk Top Size"]:checked');
  if (selectedInput) {
    handlePortholeLogic(selectedInput.value);
  }
})();


// ------------------------------------------------------
// 10. Toggle Extra Options
// ------------------------------------------------------
(function () {
  var toggleBtn = document.querySelector('#toggle-extra-options');
  var extraContainer = document.querySelector('#custom-extra-options');
  if (!toggleBtn || !extraContainer) return;

  toggleBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (
      extraContainer.style.display === 'none' ||
      !extraContainer.style.display
    ) {
      extraContainer.style.display = 'block';
      toggleBtn.innerHTML = '➖ Useful Add-Ons';
    } else {
      extraContainer.style.display = 'none';
      toggleBtn.innerHTML = '➕ Useful Add-Ons';
    }
  });
})();

// ------------------------------------------------------
// 11. VAT & Total Price Calculation
// ------------------------------------------------------
(function() {
var vatRate = 0.2;

function parsePrice(text) {
return parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
}

function formatPrice(amount) {
return '£' + amount.toFixed(2);
}

function getBasePricesFromDOM() {
var exclEl = document.querySelector('.totalprice_1');
var inclEl = document.querySelector('.totalprice');
var exclText = exclEl?.dataset.base || exclEl?.textContent || '0';
var inclText = inclEl?.dataset.base || inclEl?.textContent || '0';
//alert(inclText);
return {
excl: parsePrice(exclText),
incl: parsePrice(inclText)
};
}

function getBoldExtraInclVAT() {
var boldEl = document.querySelector('.bold_option_total .money');
var boldText = boldEl?.textContent.trim() || '0';
return parsePrice(boldText);
}

function updatePrices() {
// console.log('xcdf');
var boldIncl = getBoldExtraInclVAT();
var boldExcl = +(boldIncl / (1 + vatRate)).toFixed(2);
var base = getBasePricesFromDOM();

var newExcl = base.excl + boldExcl;
var newIncl = base.incl + boldIncl;

var exclEl = document.querySelector('.totalprice_1');
var inclEl = document.querySelector('.totalprice');
if (exclEl) exclEl.textContent = formatPrice(newExcl);
if (inclEl) inclEl.textContent = formatPrice(newIncl);

var extrasEl = document.querySelector('.bold_option_total_price');
if (boldIncl > 0) {
extrasEl.innerHTML =
'<strong>Extras:</strong> ' + formatPrice(boldIncl);
extrasEl.style.display = '';
} else {
extrasEl.style.display = 'none';
}
}

function saveBasePrices() {
var exclEl = document.querySelector('.totalprice_1');
var inclEl = document.querySelector('.totalprice');
if (!exclEl || !inclEl) return;
var excl = parsePrice(exclEl.textContent);
var incl = parsePrice(inclEl.textContent);
exclEl.dataset.base = excl;
inclEl.dataset.base = incl;
}

// Initial setup
//saveBasePrices();
//setTimeout(updatePrices, 300);

// Recalculate on Bold option or delivery change
// Recalculate on Bold option or delivery change
document.addEventListener('change', function(e) {
const isBoldCheckboxChange = e.target.matches('.bold_option_value_element input[type="checkbox"]');
const isDeliveryCardClick = e.target.closest('.delivery-options .delivery-card');
const isDeliveryDropdown = e.target.matches('#deliveryOptions');

if (isBoldCheckboxChange || isDeliveryCardClick || isDeliveryDropdown) {
setTimeout(updatePrices, 300);
}
});


})();


// ------------------------------------------------------
// 12. Accordion & “Read More” Logic for Specific Products
// ------------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  // ※ Changed: we no longer check against matchingSlugs or matchingTitles via Liquid,
  //   so this code runs on every product page. If you want it only on certain products,
  //   you could wrap in a conditional that checks for an explicit CSS class on the body.
  var ulTag = document.querySelector('.short-desc-sec ul');
  if (ulTag) {
    ulTag.id = 'myList';
  }

  var hiddenElement = document.getElementById('m-1688450943525');
  if (hiddenElement) {
    hiddenElement.style.display = 'none';
  }

  var firstLi = document.querySelector('#myList li');
  if (firstLi) {
    var breakLine = document.createElement('br');
    var readMoreLink = document.createElement('a');
    readMoreLink.href = 'javascript:void(0)';
    readMoreLink.id = 'readMoreLink';
    readMoreLink.classList.add('yy-black');
    readMoreLink.style.fontWeight = 'bold';
    readMoreLink.textContent = ' Read More...';
    firstLi.appendChild(breakLine);
    firstLi.appendChild(readMoreLink);
  }

  var readMoreLink = document.getElementById('readMoreLink');
  var list = document.getElementById('myList');
  if (readMoreLink && list) {
    var breakLine = document.createElement('br');
    var brAdded = false;

    readMoreLink.addEventListener('click', function () {
      var firstLiInner = list.querySelector('li');
      var lastLi = list.querySelector('li:last-child');

      if (list.classList.contains('show-more')) {
        list.classList.remove('show-more');
        this.textContent = ' Read More...';

        if (!brAdded) {
          firstLiInner.appendChild(breakLine);
          brAdded = true;
        }
        firstLiInner.appendChild(readMoreLink);
      } else {
        list.classList.add('show-more');
        this.textContent = ' Read Less...';

        if (!brAdded) {
          lastLi.appendChild(breakLine);
          brAdded = true;
        }
        lastLi.appendChild(readMoreLink);
      }
    });
  }
});


// ------------------------------------------------------
// 13. Compare Price & Discount Spacing
// ------------------------------------------------------
(function () {
  var comparePrice = document.querySelector(
    '#m-1688450943531 .compareprice'
  );
  var discountSelector = document.querySelector(
    '.gf_pq-discount-selector'
  );

  if (comparePrice) {
    if (
      comparePrice.style.display === 'none' ||
      (discountSelector && discountSelector.style.display === 'none')
    ) {
      comparePrice.style.marginTop = '23px';
    } else {
      comparePrice.style.marginTop = '30px';
    }
  }
})();



// ------------------------------------------------------
// 15. Accordion Auto-Open & Scroll To Warning
// ------------------------------------------------------
function scrollToWarning() {
  var warningElement = document.querySelector('p.yy-red.uk');
  if (warningElement) {
    warningElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
}

(function () {
  // ※ Changed: we simply pick the first accordion that matches this data-label/data-key
  var accordion = document.querySelector(
    '[data-label="Accordion"][data-key="accordion"] [data-index="3"]'
  );
  var accordionContent = accordion?.nextElementSibling;

  if (accordion && accordionContent) {
    var isOpen = accordionContent.style.display === 'block';
    if (!isOpen) {
      var toggleButton = accordion.querySelector('.wrapp-icon');
      if (toggleButton) {
        toggleButton.click();
      } else {
        accordion.classList.add('opend');
        accordionContent.style.display = 'block';
      }
      setTimeout(scrollToWarning, 800);
    } else {
      scrollToWarning();
    }
  }
})();


// ------------------------------------------------------
// 16. Lightbox for .gf_product-image
// ------------------------------------------------------
document.querySelectorAll('.gf_product-image').forEach(function (image) {
  // Remove existing event listeners by replacing the node
  var newImage = image.cloneNode(true);
  image.parentNode.replaceChild(newImage, image);

  newImage.addEventListener('click', function () {
    console.log('Image click event triggered');
    var currentImageSrc = this.getAttribute('src');
    console.log('Clicked image path:', currentImageSrc);

    // Create lightbox overlay
    var lightbox = document.createElement('div');
    lightbox.id = 'lightbox';
    lightbox.style.position = 'fixed';
    lightbox.style.top = '0';
    lightbox.style.left = '0';
    lightbox.style.width = '100vw';
    lightbox.style.height = '100vh';
    lightbox.style.background = 'rgba(0, 0, 0, 0.8)';
    lightbox.style.display = 'flex';
    lightbox.style.alignItems = 'center';
    lightbox.style.justifyContent = 'center';
    lightbox.style.zIndex = '1000';

    // Create image element for lightbox
    var imgEl = document.createElement('img');
    imgEl.src = currentImageSrc;
    imgEl.style.maxWidth = '90%';
    imgEl.style.maxHeight = '90%';
    imgEl.style.borderRadius = '10px';
    imgEl.style.boxShadow = '0 4px 8px rgba(255, 255, 255, 0.2)';

    console.log('Lightbox showing image path:', imgEl.src);

    lightbox.appendChild(imgEl);
    document.body.appendChild(lightbox);

    lightbox.addEventListener('click', function () {
      console.log('Lightbox closed');
      document.body.removeChild(lightbox);
    });
  });
});
//17

function waitForStableBoldAndResync() {
  let lastHTML = '';
  let checkCount = 0;
  const observerTarget = document.querySelector('.bold_option'); // Use a stable wrapper if needed

  if (!observerTarget) {
    console.warn("⚠️ Bold wrapper not found.");
    return;
  }

  const observer = new MutationObserver(() => {
    const currentHTML = observerTarget.innerHTML;
    if (currentHTML === lastHTML) {
      checkCount++;
    } else {
      checkCount = 0;
      lastHTML = currentHTML;
    }

    if (checkCount >= 3) {
      observer.disconnect();
      console.log("✅ Bold options settled, syncing now.");
      reSyncCustomOptionsToBold();
    }
  });

  observer.observe(observerTarget, {
    childList: true,
    subtree: true
  });
}

//18
function reSyncCustomOptionsToBold() {
  document.querySelectorAll('.options_checkbox[data-id]').forEach(function (customCheckbox) {
    if (!customCheckbox.checked) return;

    const selectedId = customCheckbox.dataset.id;

    // Find Bold visible checkbox input
    const boldEl = document.querySelector(
      'input[type="checkbox"][value="' + selectedId + '"]'
    );
    if (!boldEl) return;

    const wrapper = boldEl.closest('.bold_option_value_element');

    // Ensure checkbox is checked
    if (!boldEl.checked) {
      boldEl.click();
    }

    // Add visual class if not already
    if (wrapper && !wrapper.classList.contains('bold_swatch_selected')) {
      wrapper.classList.add('bold_swatch_selected');
      wrapper.setAttribute('aria-checked', 'true');
    }

    // Update the hidden helper field
    const hiddenInput = wrapper?.querySelector('input[type="hidden"]');
    if (hiddenInput && hiddenInput.name && hiddenInput.name.includes('[' + selectedId + ']')) {
      hiddenInput.value = selectedId;
    }
  });

}
// "Basic up/down switch" in custom UI
(function () {
  const DIGITAL_LABEL = 'Digital Display with Memory Settings';
  const BASIC_LABEL = 'Two-Way Control Switch';

  const path = window.location.pathname;

  // 🔒 Exclude these products from running control switch logic
  const excludedProducts = [
    'products/yo-yo-desk-home',
    'products/yo-yo-desk-rise',
    'products/yo-yo-desk-80-s',
    'products/yo-yo-desk-90',
    'products/yo-yo-desk-mini',
    'products/yo-yo-desk-learn',
    'products/yo-yo-desk-go1',
    'products/yo-yo-desk-120',
    'products/flytta-riser-small',
    'products/flytta-riser-medium',
    'products/flytta-riser-large',
    'products/yo-yo-desk-lite',
    // Add more product handles here if needed
  ];

  if (excludedProducts.some(handle => path.includes(handle))) return;

  function enforceExclusiveControlSwitch(valueToSelect) {
    const toKeep = valueToSelect;
    const toUncheck = valueToSelect === DIGITAL_LABEL ? BASIC_LABEL : DIGITAL_LABEL;

    // ✅ Select ALL checkboxes with `toKeep` value
    document.querySelectorAll(`input[type="checkbox"][value="${toKeep}"]`).forEach(input => {
      if (!input.checked) input.click();
    });

    // ❌ Deselect ALL checkboxes with `toUncheck` value
    document.querySelectorAll(`input[type="checkbox"][value="${toUncheck}"]`).forEach(input => {
      if (input.checked) input.click();
    });
  }

  function syncCustomUIControl(valueToSelect) {
    document.querySelectorAll('input.options_checkbox[name="control-switch"]').forEach(input => {
      const isMatch = input.dataset.id === valueToSelect;
      input.checked = isMatch;

      const checkmark = input.closest('.bold_option_element')?.querySelector('.checkmark');
      if (checkmark) checkmark.classList.toggle('checked', isMatch);

      const titleBox = input.closest('.sub-options')?.querySelector('.bold_option_title.custom-color');
      if (titleBox) titleBox.classList.toggle('selected', isMatch);
    });
  }

  // ✅ On custom UI radio change
  document.addEventListener('change', function (e) {
    const input = e.target;
    if (input.matches('input.options_checkbox[name="control-switch"]')) {
      const selected = input.dataset.id;
      if (!selected) return;
      enforceExclusiveControlSwitch(selected);
      syncCustomUIControl(selected);
    }
  });

  // ✅ On Bold Option checkbox click
  document.addEventListener('change', function (e) {
    const input = e.target;
    if (
      input.matches('.bold_option input[type="checkbox"]') &&
      (input.value === BASIC_LABEL || input.value === DIGITAL_LABEL)
    ) {
      const parentTitle = input.closest('.bold_option_swatch')?.querySelector('.bold_option_title')?.textContent?.trim();
      if (input.checked) {
        enforceExclusiveControlSwitch(parentTitle);
        syncCustomUIControl(parentTitle);
      } else {
        input.checked = true; // Prevent both being unchecked
      }
    }
  });

  // ✅ On page load – use pathname to determine default
  window.addEventListener('load', function () {
    const path = window.location.pathname;

    // ✅ Add more product handles here
    const proProducts = [
      '/products/yo-yo-desk-pro-2-plus',
      '/products/yo-yo-desk-pro-3-plus', // Add more as needed
    ];

    // ✅ Check if current path matches any of them
    const isProProduct = proProducts.some(handle => path.includes(handle));

    // Set default value based on product
    const defaultValue = isProProduct ? DIGITAL_LABEL : BASIC_LABEL;

    const selected = document.querySelector('input.options_checkbox[name="control-switch"]:checked');
    const selectedValue = selected?.dataset.id || defaultValue;

    enforceExclusiveControlSwitch(selectedValue);
    syncCustomUIControl(selectedValue);
  });

 })();

});

// Function to check for the selected navigation item
function checkSelectedNavigationItem() {
    var check_img = document.querySelector('.product__slides-navigation.is-nav-selected.is-selected');
    
    if (check_img) {
    } else {
    }
}



// Attach the event listener to a specific container (e.g., a parent div)
const container = document.querySelector('.product__slides-navigation-container');
container?.addEventListener('click', function() {
    checkSelectedNavigationItem();
});

setTimeout(checkSelectedNavigationItem,2000);

